import { render } from "./BellIcon.vue?vue&type=template&id=e41f4950"
const script = {}
script.render = render

export default script